import { Pipe, PipeTransform, Input } from '@angular/core';

@Pipe({
  name: 'sort'
})
export class SortPipe implements PipeTransform {
  //Campo de el objeto que se quiere ordenar
  @Input() field:string;
  //Orden que se toma ascendente o descendente
  @Input() orden?:string = 'desc';

  transform(value:Array<any>, args?: any): any {
    return value.sort();
  }

}
